/**
 * This file was auto-generated.
 * Do not make direct changes to the file.
 */
/* eslint-disable @typescript-eslint/no-unused-vars */

import { z } from 'zod'

import * as AdminCountryTypes from './admin-country-types'
import * as CommonTypes from './common-types'
import * as PublicTypes from './public-types'

export const OperatingMode = {
	Admin: 'ADMIN',
	Pos: 'POS',
	BagCheck: 'BAG_CHECK',
	Sco: 'SCO',
	Inventory: 'INVENTORY',
	Terminal: 'TERMINAL',
	Checkout: 'CHECKOUT'
} as const
export type OperatingModeType = (typeof OperatingMode)[keyof typeof OperatingMode]
export type SalesChannelType = {
	uuid: string
	name: string
	fulfillmentProvider?: CommonTypes.FulfillmentProviderType
	preauthorizationAmount?: CommonTypes.Amount
	allowCompletingUnderpaidOrders: boolean
}
export type SalesChannelGroupListItem = {
	uuid: string
	name: string
	memberCount: number
}
export type SalesChannelGroup = {
	uuid: string
	name: string
	salesChannels: {
		uuid: string
		name: string
	}[]
}
export type SalesChannelListItem = {
	uuid: string
	name: string
	currencyCode: string
	salesChannelType?: SalesChannelType
	accessKeyCount: number
	inventoryLocation?: {
		uuid: string
		name: string
	}
	group?: {
		uuid: string
		name: string
	}
}
export const AccessKeyType = {
	Publishable: 'PUBLISHABLE',
	Secret: 'SECRET'
} as const
export type AccessKeyTypeType = (typeof AccessKeyType)[keyof typeof AccessKeyType]
export type PublishableKey = {
	type: 'PUBLISHABLE'
	uuid: string
	createdAt: number
	token: string
	name: string
	salesChannels?: {
		uuid: string
		name: string
	}[]
	marketingChannel?: {
		uuid: string
		name: string
	}
}
export type ApiKey = {
	type: 'SECRET'
	uuid: string
	createdAt: number
	redacted: string
	name: string
	developmentMode: boolean
}
export type AccessKey = PublishableKey | ApiKey
export type SalesChannel = {
	uuid: string
	name: string
	currencyCode: string
	salesChannelType?: SalesChannelType
	countryCode: AdminCountryTypes.CountryCodeType
	branchName?: string
	inventoryLocation?: {
		uuid: string
		name: string
	}
	metadata?: any
	storefrontUrl?: string
	accessKeys: AccessKey[]
	pointOfSales: {
		uuid: string
		name: string
	}[]
	group?: {
		uuid: string
		name: string
	}
}
export type PointOfSaleGroupListItem = {
	uuid: string
	name: string
	memberCount: number
}
export type PointOfSaleGroup = {
	uuid: string
	name: string
	pointsOfSale: {
		uuid: string
		name: string
	}[]
}
export type PointOfSaleListItem = {
	uuid: string
	name: string
	identifier: string
	salesChannels: {
		uuid: string
		name: string
	}[]
	accessKeyCount: number
	group?: {
		uuid: string
		name: string
	}
}
export type PointOfSale = {
	uuid: string
	name: string
	identifier: string
	allowedOperatingModes: OperatingModeType[]
	salesChannels: {
		uuid: string
		name: string
	}[]
	metadata?: any
	accessKeys: AccessKey[]
	group?: {
		uuid: string
		name: string
	}
}
export type SalesChannelInfo = {
	uuid: string
	name: string
	currencyCode: string
	bagProductGroup?: string
	pickListProductGroups?: {
		uuid: string
		name: string
	}[]
	preauthorizationAmount?: CommonTypes.Amount
	storefrontUrl?: string
}
export const ForcedOrientation = {
	Portrait: 'portrait',
	'Portrait-reverse': 'portrait-reverse',
	Landscape: 'landscape',
	'Landscape-reverse': 'landscape-reverse',
	Default: 'default'
} as const
export type ForcedOrientationType = (typeof ForcedOrientation)[keyof typeof ForcedOrientation]
export const ForcedFormFactor = {
	Phone: 'phone',
	Tablet: 'tablet',
	'Large-portrait': 'large-portrait',
	'Large-landscape': 'large-landscape',
	'Large-squarish': 'large-squarish'
} as const
export type ForcedFormFactorType = (typeof ForcedFormFactor)[keyof typeof ForcedFormFactor]
export const PosMutationPermission = {
	Enabled: 'ENABLED',
	StaffNeeded: 'STAFF_NEEDED',
	Disabled: 'DISABLED'
} as const
export type PosMutationPermissionType = (typeof PosMutationPermission)[keyof typeof PosMutationPermission]
export const LogStreamLevel = {
	Off: 'OFF',
	Error: 'ERROR',
	Warn: 'WARN',
	Info: 'INFO',
	Debug: 'DEBUG'
} as const
export type LogStreamLevelType = (typeof LogStreamLevel)[keyof typeof LogStreamLevel]
export type SafeAreaInsetOverrides = {
	top?: number | null
	right?: number | null
	bottom?: number | null
	left?: number | null
}
export type CheckoutModeColorPalette = {
	background?: string | null
	foreground?: string | null
	card?: string | null
	cardForeground?: string | null
	popover?: string | null
	popoverForeground?: string | null
	primary?: string | null
	primaryForeground?: string | null
	primaryInk?: string | null
	primaryInkForeground?: string | null
	primaryButton?: string | null
	primaryButtonForeground?: string | null
	secondary?: string | null
	secondaryForeground?: string | null
	secondaryInk?: string | null
	secondaryInkForeground?: string | null
	muted?: string | null
	mutedForeground?: string | null
	accent?: string | null
	accentForeground?: string | null
	info?: string | null
	infoForeground?: string | null
	warning?: string | null
	warningForeground?: string | null
	destructive?: string | null
	destructiveForeground?: string | null
	discount?: string | null
	discountForeground?: string | null
	discountBorder?: string | null
	border?: string | null
	input?: string | null
	ring?: string | null
	washFrom?: string | null
	washTo?: string | null
}
export type CheckoutModeFontFamilies = {
	thin?: string | null
	extraLight?: string | null
	light?: string | null
	sans?: string | null
	medium?: string | null
	semiBold?: string | null
	bold?: string | null
	extraBold?: string | null
	heavy?: string | null
	black?: string | null
}
export type CheckoutModeTheme = {
	colors?: CheckoutModeColorPalette | null
	fonts?: CheckoutModeFontFamilies | null
}
export type DeviceConfig = {
	allowedOperatingModes: OperatingModeType[]
	defaultPaymentMethod?: CommonTypes.PaymentProviderType | CommonTypes.PaymentMethodType | string | null
	forcedOrientation?: ForcedOrientationType | null
	forcedFormFactor?: ForcedFormFactorType | null
	language?: string | null
	showPrinterDisconnected?: boolean | null
	productListColumns?: number | null
	browseEnabled?: PosMutationPermissionType | null
	adjustQuantity?: PosMutationPermissionType | null
	clearCart?: PosMutationPermissionType | null
	itemDeletion?: PosMutationPermissionType | null
	orderRestart?: PosMutationPermissionType | null
	splitPercentHorizontal?: number | null
	splitPercentVertical?: number | null
	itemAddedSound?: string | null
	productNotFoundSound?: string | null
	addToCartFailedSound?: string | null
	paymentSuccessSound?: string | null
	paymentFailedSound?: string | null
	logStreamLevel?: LogStreamLevelType | null
	logStreamId?: string | null
	inactivityThresholdSeconds?: number | null
	abandonCountdownSeconds?: number | null
	coolerReadyTimeoutSeconds?: number | null
	safeAreaInsets?: SafeAreaInsetOverrides | null
	checkoutModeTheme?: CheckoutModeTheme | null
	checkoutModeIdleTimeoutSeconds?: number | null
}
export type PointOfSaleInfo = {
	uuid: string
	name: string
	identifier: string
	allowedOperatingModes: OperatingModeType[]
	metadata?: any
	salesChannels: SalesChannelInfo[]
	config: DeviceConfig
	developmentMode?: boolean
}
export type CashFloatResponse = {
	success: boolean
}
export type PointOfSaleDeviceUpdateInfo = {
	updateId?: string | null
	channel?: string | null
	runtimeVersion?: string | null
	createdAt?: string | null
	isEmbeddedLaunch?: boolean
	updatePending?: boolean
	pendingSince?: number | null
}
export type PointOfSaleDeviceAppState = {
	operatingMode?: string | null
	selectedSalesChannelUuid?: string | null
	activeOrderUuid?: string | null
}
export type PointOfSaleDeviceHealth = {
	printerConnected?: boolean
	scannerConnected?: boolean
	paymentTerminalReachable?: boolean
}
export type PointOfSaleDeviceMdmInfo = {
	provider?: string | null
	deviceUuid?: string | null
}
export type PointOfSaleDeviceStatusReport = {
	appVersion?: string
	displayRuntimeVersion?: string
	configuredRuntimeVersion?: string
	nativeBuildVersion?: string | null
	platform?: string
	platformVersion?: string | null
	deviceModel?: string | null
	networkType?: string | null
	update: PointOfSaleDeviceUpdateInfo
	appState: PointOfSaleDeviceAppState
	health: PointOfSaleDeviceHealth
	mdm?: PointOfSaleDeviceMdmInfo
	env: any
}
export type PointOfSaleDeviceStatus = PointOfSaleDeviceStatusReport & {
	reportedAt: number
}
export const MdmProvider = {
	Eloview: 'ELOVIEW',
	Gms: 'GMS'
} as const
export type MdmProviderType = (typeof MdmProvider)[keyof typeof MdmProvider]
export const GmsPolicyPreset = {
	Elo: 'ELO',
	Zebra: 'ZEBRA',
	ManagedApp: 'MANAGED_APP',
	Debugging: 'DEBUGGING'
} as const
export type GmsPolicyPresetType = (typeof GmsPolicyPreset)[keyof typeof GmsPolicyPreset]
export const GmsWifiSecurity = {
	Open: 'OPEN',
	WpaPsk: 'WPA_PSK'
} as const
export type GmsWifiSecurityType = (typeof GmsWifiSecurity)[keyof typeof GmsWifiSecurity]
export type GmsWifiNetwork = {
	ssid: string
	security: GmsWifiSecurityType
	hidden: boolean
	hasPassword: boolean
}
export type PointOfSaleAmapiStatus = {
	mdmProvider: MdmProviderType
	deviceName?: string | null
	minimumVersionCode?: number | null
	policyPresets?: GmsPolicyPresetType[]
	wifiNetworks?: GmsWifiNetwork[]
	trackId?: string | null
	policyOverrides?: any | null
	state?: string | null
	appliedState?: string | null
	policyCompliant?: boolean | null
	nonComplianceReasons?: string[]
	lastPolicySyncTime?: string | null
	installedVersionCode?: number | null
	hardwareModel?: string | null
	androidVersion?: string | null
}
export type PointOfSaleEnrolledDevice = {
	deviceInfo: PublicTypes.DeviceEnrollmentDeviceInfo
	enrolledAt: number
	redacted: string
}
export type DeviceEnrollmentLookupResponse = {
	deviceInfo: PublicTypes.DeviceEnrollmentDeviceInfo
	currentDevice?: PointOfSaleEnrolledDevice | null
}
export type GmsPlayTrack = {
	trackId: string
	trackAlias?: string | null
	versionCode?: number | null
	versionString?: string | null
}
export type ApiKeyCreatedResponse = ApiKey & {
	token: string
}
export type GmsWifiNetworkInput = {
	ssid: string
	security: GmsWifiSecurityType
	password?: string | null
	hidden?: boolean
}

export const zOperatingMode = z.enum(['ADMIN', 'POS', 'BAG_CHECK', 'SCO', 'INVENTORY', 'TERMINAL', 'CHECKOUT'])
export const zSalesChannelType = z.object({
	uuid: z.string(),
	name: z.string(),
	fulfillmentProvider: CommonTypes.zFulfillmentProvider.optional(),
	preauthorizationAmount: CommonTypes.zAmount.optional().nullable(),
	allowCompletingUnderpaidOrders: z.boolean()
})
export const zSalesChannelGroupListItem = z.object({
	uuid: z.string(),
	name: z.string(),
	memberCount: z.number()
})
export const zSalesChannelGroup = z.object({
	uuid: z.string(),
	name: z.string(),
	salesChannels: z.array(
		z.object({
			uuid: z.string(),
			name: z.string()
		})
	)
})
export const zSalesChannelListItem = z.object({
	uuid: z.string(),
	name: z.string(),
	currencyCode: z.string(),
	salesChannelType: zSalesChannelType.optional().nullable(),
	accessKeyCount: z.number(),
	inventoryLocation: z
		.object({
			uuid: z.string(),
			name: z.string()
		})
		.optional(),
	group: z
		.object({
			uuid: z.string(),
			name: z.string()
		})
		.optional()
})
export const zAccessKeyType = z.enum(['PUBLISHABLE', 'SECRET'])
export const zPublishableKey = z.object({
	type: z.enum(['PUBLISHABLE']),
	uuid: z.string(),
	createdAt: z.number(),
	token: z.string(),
	name: z.string(),
	salesChannels: z
		.array(
			z.object({
				uuid: z.string(),
				name: z.string()
			})
		)
		.optional(),
	marketingChannel: z
		.object({
			uuid: z.string(),
			name: z.string()
		})
		.optional()
})
export const zApiKey = z.object({
	type: z.enum(['SECRET']),
	uuid: z.string(),
	createdAt: z.number(),
	redacted: z.string(),
	name: z.string(),
	developmentMode: z.boolean()
})
export const zAccessKey = z.union([zPublishableKey, zApiKey])
export const zSalesChannel = z.object({
	uuid: z.string(),
	name: z.string(),
	currencyCode: z.string(),
	salesChannelType: zSalesChannelType.optional().nullable(),
	countryCode: AdminCountryTypes.zCountryCode,
	branchName: z.string().optional(),
	inventoryLocation: z
		.object({
			uuid: z.string(),
			name: z.string()
		})
		.optional(),
	metadata: z.any().optional(),
	storefrontUrl: z.string().optional(),
	accessKeys: z.array(zAccessKey),
	pointOfSales: z.array(
		z.object({
			uuid: z.string(),
			name: z.string()
		})
	),
	group: z
		.object({
			uuid: z.string(),
			name: z.string()
		})
		.optional()
})
export const zPointOfSaleGroupListItem = z.object({
	uuid: z.string(),
	name: z.string(),
	memberCount: z.number()
})
export const zPointOfSaleGroup = z.object({
	uuid: z.string(),
	name: z.string(),
	pointsOfSale: z.array(
		z.object({
			uuid: z.string(),
			name: z.string()
		})
	)
})
export const zPointOfSaleListItem = z.object({
	uuid: z.string(),
	name: z.string(),
	identifier: z.string(),
	salesChannels: z.array(
		z.object({
			uuid: z.string(),
			name: z.string()
		})
	),
	accessKeyCount: z.number(),
	group: z
		.object({
			uuid: z.string(),
			name: z.string()
		})
		.optional()
})
export const zPointOfSale = z.object({
	uuid: z.string(),
	name: z.string(),
	identifier: z.string(),
	allowedOperatingModes: z.array(zOperatingMode),
	salesChannels: z.array(
		z.object({
			uuid: z.string(),
			name: z.string()
		})
	),
	metadata: z.any().optional(),
	accessKeys: z.array(zAccessKey),
	group: z
		.object({
			uuid: z.string(),
			name: z.string()
		})
		.optional()
})
export const zSalesChannelInfo = z.object({
	uuid: z.string(),
	name: z.string(),
	currencyCode: z.string(),
	bagProductGroup: z.string().optional(),
	pickListProductGroups: z
		.array(
			z.object({
				uuid: z.string(),
				name: z.string()
			})
		)
		.optional(),
	preauthorizationAmount: CommonTypes.zAmount.optional().nullable(),
	storefrontUrl: z.string().optional()
})
export const zForcedOrientation = z.enum(['portrait', 'portrait-reverse', 'landscape', 'landscape-reverse', 'default'])
export const zForcedFormFactor = z.enum(['phone', 'tablet', 'large-portrait', 'large-landscape', 'large-squarish'])
export const zPosMutationPermission = z.enum(['ENABLED', 'STAFF_NEEDED', 'DISABLED'])
export const zLogStreamLevel = z.enum(['OFF', 'ERROR', 'WARN', 'INFO', 'DEBUG'])
export const zSafeAreaInsetOverrides = z.object({
	top: z.number().optional().nullable(),
	right: z.number().optional().nullable(),
	bottom: z.number().optional().nullable(),
	left: z.number().optional().nullable()
})
export const zCheckoutModeColorPalette = z.object({
	background: z.string().optional().nullable(),
	foreground: z.string().optional().nullable(),
	card: z.string().optional().nullable(),
	cardForeground: z.string().optional().nullable(),
	popover: z.string().optional().nullable(),
	popoverForeground: z.string().optional().nullable(),
	primary: z.string().optional().nullable(),
	primaryForeground: z.string().optional().nullable(),
	primaryInk: z.string().optional().nullable(),
	primaryInkForeground: z.string().optional().nullable(),
	primaryButton: z.string().optional().nullable(),
	primaryButtonForeground: z.string().optional().nullable(),
	secondary: z.string().optional().nullable(),
	secondaryForeground: z.string().optional().nullable(),
	secondaryInk: z.string().optional().nullable(),
	secondaryInkForeground: z.string().optional().nullable(),
	muted: z.string().optional().nullable(),
	mutedForeground: z.string().optional().nullable(),
	accent: z.string().optional().nullable(),
	accentForeground: z.string().optional().nullable(),
	info: z.string().optional().nullable(),
	infoForeground: z.string().optional().nullable(),
	warning: z.string().optional().nullable(),
	warningForeground: z.string().optional().nullable(),
	destructive: z.string().optional().nullable(),
	destructiveForeground: z.string().optional().nullable(),
	discount: z.string().optional().nullable(),
	discountForeground: z.string().optional().nullable(),
	discountBorder: z.string().optional().nullable(),
	border: z.string().optional().nullable(),
	input: z.string().optional().nullable(),
	ring: z.string().optional().nullable(),
	washFrom: z.string().optional().nullable(),
	washTo: z.string().optional().nullable()
})
export const zCheckoutModeFontFamilies = z.object({
	thin: z.string().optional().nullable(),
	extraLight: z.string().optional().nullable(),
	light: z.string().optional().nullable(),
	sans: z.string().optional().nullable(),
	medium: z.string().optional().nullable(),
	semiBold: z.string().optional().nullable(),
	bold: z.string().optional().nullable(),
	extraBold: z.string().optional().nullable(),
	heavy: z.string().optional().nullable(),
	black: z.string().optional().nullable()
})
export const zCheckoutModeTheme = z.object({
	colors: zCheckoutModeColorPalette.optional().nullable(),
	fonts: zCheckoutModeFontFamilies.optional().nullable()
})
export const zDeviceConfig = z.object({
	allowedOperatingModes: z.array(zOperatingMode),
	defaultPaymentMethod: z
		.union([CommonTypes.zPaymentProvider, CommonTypes.zPaymentMethod, z.string()])
		.optional()
		.nullable(),
	forcedOrientation: zForcedOrientation.optional().nullable(),
	forcedFormFactor: zForcedFormFactor.optional().nullable(),
	language: z.string().optional().nullable(),
	showPrinterDisconnected: z.boolean().optional().nullable(),
	productListColumns: z.number().optional().nullable(),
	browseEnabled: zPosMutationPermission.optional().nullable(),
	adjustQuantity: zPosMutationPermission.optional().nullable(),
	clearCart: zPosMutationPermission.optional().nullable(),
	itemDeletion: zPosMutationPermission.optional().nullable(),
	orderRestart: zPosMutationPermission.optional().nullable(),
	splitPercentHorizontal: z.number().optional().nullable(),
	splitPercentVertical: z.number().optional().nullable(),
	itemAddedSound: z.string().optional().nullable(),
	productNotFoundSound: z.string().optional().nullable(),
	addToCartFailedSound: z.string().optional().nullable(),
	paymentSuccessSound: z.string().optional().nullable(),
	paymentFailedSound: z.string().optional().nullable(),
	logStreamLevel: zLogStreamLevel.optional().nullable(),
	logStreamId: z.string().optional().nullable(),
	inactivityThresholdSeconds: z.number().optional().nullable(),
	abandonCountdownSeconds: z.number().optional().nullable(),
	coolerReadyTimeoutSeconds: z.number().optional().nullable(),
	safeAreaInsets: zSafeAreaInsetOverrides.optional().nullable(),
	checkoutModeTheme: zCheckoutModeTheme.optional().nullable(),
	checkoutModeIdleTimeoutSeconds: z.number().optional().nullable()
})
export const zPointOfSaleInfo = z.object({
	uuid: z.string(),
	name: z.string(),
	identifier: z.string(),
	allowedOperatingModes: z.array(zOperatingMode),
	metadata: z.any().optional(),
	salesChannels: z.array(zSalesChannelInfo),
	config: zDeviceConfig,
	developmentMode: z.boolean().optional()
})
export const zCashFloatResponse = z.object({
	success: z.boolean()
})
export const zPointOfSaleDeviceUpdateInfo = z.object({
	updateId: z.string().optional().nullable(),
	channel: z.string().optional().nullable(),
	runtimeVersion: z.string().optional().nullable(),
	createdAt: z.string().optional().nullable(),
	isEmbeddedLaunch: z.boolean().optional(),
	updatePending: z.boolean().optional(),
	pendingSince: z.number().optional().nullable()
})
export const zPointOfSaleDeviceAppState = z.object({
	operatingMode: z.string().optional().nullable(),
	selectedSalesChannelUuid: z.string().optional().nullable(),
	activeOrderUuid: z.string().optional().nullable()
})
export const zPointOfSaleDeviceHealth = z.object({
	printerConnected: z.boolean().optional(),
	scannerConnected: z.boolean().optional(),
	paymentTerminalReachable: z.boolean().optional()
})
export const zPointOfSaleDeviceMdmInfo = z.object({
	provider: z.string().optional().nullable(),
	deviceUuid: z.string().optional().nullable()
})
export const zPointOfSaleDeviceStatusReport = z.object({
	appVersion: z.string().optional(),
	displayRuntimeVersion: z.string().optional(),
	configuredRuntimeVersion: z.string().optional(),
	nativeBuildVersion: z.string().optional().nullable(),
	platform: z.string().optional(),
	platformVersion: z.string().optional().nullable(),
	deviceModel: z.string().optional().nullable(),
	networkType: z.string().optional().nullable(),
	update: zPointOfSaleDeviceUpdateInfo,
	appState: zPointOfSaleDeviceAppState,
	health: zPointOfSaleDeviceHealth,
	mdm: zPointOfSaleDeviceMdmInfo.optional().nullable(),
	env: z.any()
})
export const zPointOfSaleDeviceStatus = z.intersection(
	zPointOfSaleDeviceStatusReport,
	z.object({
		reportedAt: z.number()
	})
)
export const zMdmProvider = z.enum(['ELOVIEW', 'GMS'])
export const zGmsPolicyPreset = z.enum(['ELO', 'ZEBRA', 'MANAGED_APP', 'DEBUGGING'])
export const zGmsWifiSecurity = z.enum(['OPEN', 'WPA_PSK'])
export const zGmsWifiNetwork = z.object({
	ssid: z.string(),
	security: zGmsWifiSecurity,
	hidden: z.boolean(),
	hasPassword: z.boolean()
})
export const zPointOfSaleAmapiStatus = z.object({
	mdmProvider: zMdmProvider,
	deviceName: z.string().optional().nullable(),
	minimumVersionCode: z.number().optional().nullable(),
	policyPresets: z.array(zGmsPolicyPreset).optional(),
	wifiNetworks: z.array(zGmsWifiNetwork).optional(),
	trackId: z.string().optional().nullable(),
	policyOverrides: z.any().nullable().optional(),
	state: z.string().optional().nullable(),
	appliedState: z.string().optional().nullable(),
	policyCompliant: z.boolean().optional().nullable(),
	nonComplianceReasons: z.array(z.string()).optional(),
	lastPolicySyncTime: z.string().optional().nullable(),
	installedVersionCode: z.number().optional().nullable(),
	hardwareModel: z.string().optional().nullable(),
	androidVersion: z.string().optional().nullable()
})
export const zPointOfSaleEnrolledDevice = z.object({
	deviceInfo: PublicTypes.zDeviceEnrollmentDeviceInfo,
	enrolledAt: z.number(),
	redacted: z.string()
})
export const zDeviceEnrollmentLookupResponse = z.object({
	deviceInfo: PublicTypes.zDeviceEnrollmentDeviceInfo,
	currentDevice: zPointOfSaleEnrolledDevice.optional().nullable()
})
export const zGmsPlayTrack = z.object({
	trackId: z.string(),
	trackAlias: z.string().optional().nullable(),
	versionCode: z.number().optional().nullable(),
	versionString: z.string().optional().nullable()
})
export const zApiKeyCreatedResponse = z.intersection(
	zApiKey,
	z.object({
		token: z.string()
	})
)
export const zGmsWifiNetworkInput = z.object({
	ssid: z.string(),
	security: zGmsWifiSecurity,
	password: z.string().optional().nullable(),
	hidden: z.boolean().optional()
})
